import { render } from "./Client_Map_Department.vue?vue&type=template&id=d346d234"
import script from "./Client_Map_Department.vue?vue&type=script&lang=js"
export * from "./Client_Map_Department.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__